import { Button } from "./Button";

interface Props extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'size'> {
  isEnabled?: boolean;
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const ToggleableButton: React.FC<Props> = ({
  isEnabled = true,
  className,
  id,
  children,
  ...props
}) => {
  return (
    <>
      {isEnabled ? (
        <Button
          {...props}
          type="submit"
          className={`rounded-[8px] / h-[48px] /
                     bg-[#4285F4] hover:bg-[#3367D6] text-white /
                     transition-colors ${className}`}
        >
          {children}
        </Button>
      ) : (
        <div
          className={`text-sm / flex justify-center items-center / rounded-[8px] /
                     h-[48px] bg-[#f2f2f2] text-[#aeaeae] ${className}`}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default ToggleableButton;
